import {
  SkeletonLoader,
  NoGoalsDefined,
  NoToplineGoals,
} from 'containers/user/home/components/widgets/goals-widget/goals-widget-states';
import GoalsCarusel from 'containers/user/home/components/widgets/goals-widget/goal-carusel';
import ErrorWidget from 'containers/user/home/components/widgets/error-widget';
import NavButton from 'containers/user/home/components/shared/navigation-button';

import Icons from 'assets/icons';

export const goalsConfig = {
  colSpan: 1,
  rowSpan: {
    default: 9,
  },
};

interface Goal {
  summary?: string;
  [key: string]: unknown;
}

const renderContent = (goals: Goal[], error: unknown): React.JSX.Element => {
  if (error) return <ErrorWidget />;
  if (!goals.length) return <NoToplineGoals />;

  return <GoalsCarusel goals={goals} />;
};

interface GoalsWidgetProps {
  loading?: boolean;
  error?: unknown;
  goals?: Goal[];
  hasClientGoals?: boolean;
}

const GoalsWidget = ({
  loading,
  error,
  goals = [],
  hasClientGoals = true,
}: GoalsWidgetProps): React.JSX.Element => {
  const handleEmailClick = (): void => {
    window.location.href = 'mailto:clientsupport@marketviewedu.com';
  };

  if (loading) return <SkeletonLoader />;
  if (!hasClientGoals)
    return <NoGoalsDefined handleEmailClick={handleEmailClick} />;

  return (
    <div className="h-full bg-white border border-navy-200 rounded-lg flex flex-col p-5 pt-4">
      <div className="flex items-center gap-2 mb-4">
        <Icons.Target className="h-5 w-5 text-navy-400" />
        <div className="font-bold text-xl">Your goals</div>
      </div>

      {renderContent(goals, error)}

      {!error && (
        <NavButton link="/goals" text="View your goals" customClass="mt-4" />
      )}
    </div>
  );
};

export default GoalsWidget;
